// extracted by mini-css-extract-plugin
export default {"infoTitle":"infoTitle---mL0k7","infoContent":"infoContent---O_6ob"};